import {
	CreateDrawerFormProps,
	DateField,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	SingleSelectField,
	TextField,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BranchSelectField } from "~root/branches/BranchSelectField";
import { CountrySelectField, StateSelectField } from "~root/country/CountrySelectField";
import { UserSelectField } from "~root/users/UserSelectField";
import { ALL_GENDERS, IEmployeeCreateFormState } from "~shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IEmployeeCreateFormState) => {
		const errors: { [K in keyof IEmployeeCreateFormState]?: any } = {};

		if (!values.firstName) {
			errors.firstName = t("Field is required");
		}
		if (!values.lastName) {
			errors.lastName = t("Field is required");
		}
		if (!values.hoursPerDay) {
			errors.hoursPerDay = t("Field is required");
		}
		if (!values.dateOfBirth) {
			errors.dateOfBirth = t("Field is required");
		}
		if (!values.entryDate) {
			errors.entryDate = t("Field is required");
		}

		return errors;
	};
};

const initialValues: IEmployeeCreateFormState = {
	firstName: "",
	lastName: "",
	street: null,
	houseNumber: null,
	postalCode: null,
	city: null,
	country: null,
	placeOfBirth: null,
	countryOfBirth: null,
	dateOfBirth: null,
	entryDate: "",
	leaveDate: null,
	gender: null,
	iban: null,
	yearlyVacationDays: 28,
	hoursPerDay: 8,
	user: null,
	branch: null,
	employeeNumber: "",
};

const EmployeeDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="firstName" label={t("First name")} required />
			<TextField name="lastName" label={t("Last name")} required />
			<TextField name="employeeNumber" label={t("Employee number")} required />
			<TextField name="street" label={t("Street")} />
			<TextField name="houseNumber" label={t("House number")} />
			<TextField name="postalCode" label={t("Postal code")} />
			<TextField name="city" label={t("City")} />
			<CountrySelectField name="country" label={t("Country")} />
			<StateSelectField name="state" label={t("State")} />
			<TextField name="placeOfBirth" label={t("Place of birth")} />
			<TextField name="countryOfBirth" label={t("Country of birth")} />
			<DateField name="dateOfBirth" label={t("Date of birth")} required />
			<DateField name="entryDate" label={t("Entry date")} required />
			<DateField name="leaveDate" label={t("Leave date")} />
			<SingleSelectField name="gender" label={t("Gender")} options={[...ALL_GENDERS]} getLabel={t} />
			<TextField name="iban" label={t("IBAN")} />
			<TextField name="yearlyVacationDays" label={t("Yearly vacation days")} required type="number" />
			<TextField name="hoursPerDay" label={t("Hours per day")} type="number" required />
			<UserSelectField name="user" label={t("User")} />
			<BranchSelectField name="branch" label={t("Branch")} />
		</FormDrawerContent>
	);
};

export const EmployeeCreateDrawer: FC<CreateDrawerFormProps<IEmployeeCreateFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			{...drawerProps}
			title={t("Add employee")}
			initialValues={initialValues}
			validate={validate}
			renderForm={(props) => <EmployeeDrawerContent {...props} />}
		/>
	);
};
